import React from "react";
import AppHeader from "../../../components/Header/Header";
import AppLayout from "../../../components/layout";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import { Link } from 'react-router-dom';
import BannerSection from '../../../components/BannerSection';
import BreadcrumbNav from '../../../components/BreadcrumbNav';
import './Noticias.css'; // Arquivo CSS separado para estilização

// Componente de Card de Notícia reutilizável
const NewsCard = ({ noticia }) => {
  return (
    <Col lg={4} md={6} sm={12} className="mb-4">
      <Card className="news-card h-100 shadow-sm">
        <Link to={`/comunicacao/noticias/${noticia.id}`} className="text-decoration-none">
          <div className="card-image-container">
            <Card.Img 
              variant="top" 
              src={noticia.image} 
              alt={noticia.title}
              className="card-image"
            />
            <div className="card-overlay"></div>
          </div>
          <Card.Body className="d-flex flex-column">
            <Card.Title className="news-card-title">
              {noticia.title}
            </Card.Title>
            <Card.Text className="news-card-text flex-grow-1">
              {noticia.subtitle}
            </Card.Text>
            <div className="read-more-link mt-auto">
              <span>Ler mais</span>
              <i className="bi bi-arrow-right"></i>
            </div>
          </Card.Body>
        </Link>
      </Card>
    </Col>
  );
};

// Componente de Seção de Notícias
const NewsSection = ({ title, subtitle, noticias }) => {
  return (
    <Container className="my-5">
      <div className="section-header text-center mb-5">
        <h1 className="section-title">
          <i className="bi bi-star-fill title-icon"></i>
          {title}
        </h1>
        <p className="section-subtitle">
          {subtitle}
        </p>
        <div className="title-underline"></div>
      </div>
      
      <Row>
        {noticias.map(noticia => (
          <NewsCard key={noticia.id} noticia={noticia} />
        ))}
      </Row>
    </Container>
  );
};

export default function Noticias() {

  const caminho = [
    { label: 'Home', href: '/', icon: 'bi bi-house-door' },
    { label: 'Comunicação' },
    { label: 'Notícias'}
  ];

  const NoticiaData = [
    {
      id: 1,
      link: '/jornadacientifica',
      image: require('../../../assets/Not_23.jpeg'),
      title: 'Encerramento do ano no ISPA Atlântida',
      subtitle: 'O Instituto Superior Politécnico Atlântida (ISPA) realizou, no dia 23 de Dezembro de 2025, uma cerimônia de encerramento do ano letivo repleta de celebrações e conquistas acadêmicas.'
    },
    {
      id: 2,
      link: '# ',
      image: require('../../../assets/Not_15_Capa.jpg'),
      title: 'Brasil e Angola unidos por laços espirituais e acadêmicos: Visita do Reverendo Sérgio ao ISPA Atlântida',
      subtitle: 'ISPA Atlântida e Instituto Azusa fortalecem laços acadêmicos e espirituais em encontro histórico marcado por homenagens e diálogo construtivo.'
    },
    {
      id: 3,
      link: '/portal-do-estudante/cursos-online',
      image: require('../../../assets/img-hero2.jpeg'),
      title: 'Curso de Curta Duração: O Caminho Rápido para o Sucesso Profissional',
      subtitle: 'Descubra nossos cursos de curta duração, projetados para impulsionar sua carreira e expandir seus horizontes em tempo recorde. Com uma variedade de opções, desde tecnologia até artes, oferecemos aprendizado prático e relevante para o mercado atual. Inscreva-se hoje e dê o próximo passo rumo ao sucesso profissional!'
    },
  ];

  const worksDataSecound = [
    {
      id: 4,
      link: '/jornadacientifica',
      image: require('../../../assets/Not_01.jpg'),
      title: 'Educação e Formação Científica',
      subtitle: 'A Pesquisa como Caminho para o Conhecimento. A Jornada Científica é um espaço dedicado à promoção do conhecimento, da investigação e da inovação'
    },
    {
      id: 5,
      link: '#',
      image: require('../../../assets/Not_02.jpg'),
      title: 'Formação de Qualidade para um Futuro Brilhante',
      subtitle: 'Prepare-se para os desafios do mercado de trabalho com a melhor educação. Aqui, você encontra o suporte, o conhecimento e as ferramentas necessárias para alcançar grandes conquistas.'
    },
    {
      id: 6,
      link: '#',
      image: require('../../../assets/Not_03.jpg'),
      title: 'O Seu Futuro Profissional Merece o Melhor',
      subtitle: 'Com a formação certa, você está a um passo de transformar seus sonhos em realidade. Invista em você, aprenda com os melhores e prepare-se para um futuro de sucesso. Estamos aqui para te ajudar a alcançar o topo.'
    },
    {
      id: 7,
      link: '#',
      image: require('../../../assets/Not_05.jpg'),
      title: 'Palestra sobre a violência Doméstica',
      subtitle: 'Na palestra sobre a violência doméstica, realizada em uma data não especificada, especialistas e ativistas se reuniram para discutir esse tema crucial.'
    },
    {
      id: 8,
      link: '#',
      image: require('../../../assets/Not_06.jpg'),
      title: 'Lançamento da ROC- Revista Olhar Científico',
      subtitle: 'No lançamento da ROC - Revista Olhar Científico, um evento marcante ocorrido em uma data específica não fornecida, a comunidade acadêmica se reuniu para celebrar a inauguração desta importante plataforma de divulgação científica.'
    },
    {
      id: 9,
      link: '#',
      image: require('../../../assets/Not_08.jpg'),
      title: 'Batismo dos Caloiros ISPA 2023',
      subtitle: 'No Batismo dos Caloiros do ISPA em 2023, os novos estudantes foram recebidos em uma atmosfera de camaradagem e tradição. O evento, realizado com entusiasmo pela comunidade acadêmica.'
    },
  ];

  return (
    <div className="App">
      <BannerSection
        title="Notícias"
        subtitle="Acompanhe as últimas atualizações e eventos do ISPA Atlântida"
        description={`Bem-vindo à seção de notícias do ISPA Atlântida, onde você encontra as últimas atualizações, eventos e informações relevantes sobre nossa instituição. Fique por dentro das novidades e acompanhe nosso compromisso com a excelência acadêmica e a inovação.`}
        backgroundImage={require('../../../assets/img2.jpg')}
        backgroundId="instituition-Banner"
      />
      
      <BreadcrumbNav items={caminho} />
      
      <header id='header'>    
        <AppHeader />
      </header>
      
      <main className="noticias-main">
        {/* Seção de Notícias em Destaque */}
        <NewsSection 
          title="Notícias em Destaque"
          subtitle="Fique por dentro das notícias mais recentes e relevantes"
          noticias={NoticiaData}
        />
        
        {/* Seção de Todas as Notícias */}
        <NewsSection 
          title="Todas as Notícias"
          subtitle="Veja o histórico completo de publicações e atualizações do nosso portal"
          noticias={worksDataSecound}
        />
        
      </main>
      
      <AppLayout />
    </div>
  );
}